import React from 'react';
import { BoxV2 as Box } from 'portal-commons';
import { act } from 'react-dom/test-utils';

interface TabPanelProps {
  active: boolean;
}

const TabPanel: React.FC<TabPanelProps> = ({ active, children }) => {
  return (
    <Box sx={{ display: active ? 'block' : 'none', width: '100%' }}>
      {children}
    </Box>
  );
};

export default TabPanel;
